import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import Search from "@material-ui/icons/Search";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";

import {
  Grid,
  Button,
  Typography,
  IconButton,
  InputAdornment,
} from "@material-ui/core";

import {
  getSearchTermFromState,
  getCardSearchResultsFromState,
  getGroupSearchResultsFromState,
} from "features/planner/planner.selectors";

import {
  ACTIONS,
  SEARCH_OBJECT_TYPES,
} from "features/planner/planner.constants";

import { EMPTY_LIST } from "app/app.constants";
import SearchField from "app/components/SearchField";
import { isSearchTermValid } from "utils/validation.util";
import SidePanel from "features/planner/components/SidePanel";
import { getActionDataStateFromState } from "app/app.selectors";
import GroupHeader from "features/planner/components/Group/GroupHeader";
import { searchView, clearSearch } from "features/planner/planner.actions";
import { searchObjectTypeToString } from "features/planner/planner.mappers";
import CardSearchResult from "features/planner/components/Search/CardSearchResult";

class SearchSidePanel extends PureComponent {
  constructor(props) {
    super(props);

    const { searchTerm } = this.props;

    this.state = {
      value: searchTerm,
    };

    this.input = React.createRef();
  }

  onChange = value => {
    this.setState({ value });
  };

  startSearch = event => {
    event.preventDefault();

    const { dispatchSearch, viewId } = this.props;

    dispatchSearch(viewId, this.state.value);
  };

  clearSearch = () => {
    const { dispatchClearSearch, viewId } = this.props;

    this.setState(
      {
        value: "",
      },
      () => dispatchClearSearch(viewId),
    );
  };

  render() {
    const {
      classes,
      dataState,
      searchTerm,
      togglePanel,
      cardSearchResults,
      groupSearchResults,
    } = this.props;

    return (
      <SidePanel>
        <Grid container direction="column" spacing={4}>
          <Grid container item>
            <Grid item xs component={Typography} variant="h6">
              Search
            </Grid>
            {searchTerm && (
              <Button
                size="small"
                variant="outlined"
                onClick={this.clearSearch}
                className={classes.clearButton}
              >
                Clear
              </Button>
            )}
            <Button
              size="small"
              variant="outlined"
              onClick={togglePanel}
              className={classes.closeButton}
            >
              Close
            </Button>
          </Grid>
          <Grid container item component="form" onSubmit={this.startSearch}>
            <SearchField
              timeout={0}
              inputRef={this.input}
              value={this.state.value}
              onChange={this.onChange}
              TextFieldProps={{
                autoFocus: true,
                fullWidth: true,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      title="Search"
                      size="medium"
                      type="submit"
                      color="secondary"
                      onClick={this.startSearch}
                      className={classes.searchBtn}
                      disabled={
                        !isSearchTermValid(this.state.value) ||
                        dataState.isLoading()
                      }
                    >
                      <Search fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          {!!cardSearchResults.size && (
            <Grid container item>
              <Grid
                item
                component={Typography}
                className={classes.searchResultHeader}
              >
                {`${searchObjectTypeToString(SEARCH_OBJECT_TYPES.CARD)} (${
                  cardSearchResults.size
                })`}
              </Grid>
              {cardSearchResults.map(result => (
                <Grid
                  item
                  container
                  key={result.get("id")}
                  className={classes.cardGroup}
                >
                  <CardSearchResult cardId={result.get("id")} />
                </Grid>
              ))}
            </Grid>
          )}
          {!!groupSearchResults.size && (
            <Grid container item>
              <Grid
                item
                component={Typography}
                className={classes.searchResultHeader}
              >
                {`${searchObjectTypeToString(SEARCH_OBJECT_TYPES.GROUP)} (${
                  groupSearchResults.size
                })`}
              </Grid>
              {groupSearchResults.map(result => (
                <Grid
                  item
                  container
                  key={result.get("id")}
                  className={classes.groupResultItem}
                >
                  <GroupHeader
                    disableFlagTypeBtn
                    displayMenu={false}
                    displayDeleteBtn={false}
                    displayExpandBtn={false}
                    groupId={result.get("id")}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </SidePanel>
    );
  }
}

SearchSidePanel.defaultProps = {
  cardSearchResults: EMPTY_LIST,
  groupSearchResults: EMPTY_LIST,
};

const styles = theme => ({
  searchResultHeader: {
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  cardGroup: {
    background: grey[100],
    borderBottom: "1px solid white",
  },
  groupIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    fill: theme.palette.text.primary,
  },
  groupResultItem: {
    borderBottom: "1px solid white",
  },
  closeButton: {
    textTransform: "none",
  },
  searchBtn: {
    padding: theme.spacing(1),
    marginRight: theme.spacing(0.5),
    background: theme.palette.primary.light,
    "&:hover": {
      background: theme.palette.primary.main,
    },
  },
  clearButton: {
    textTransform: "none",
    marginRight: theme.spacing(0.5),
  },
});

export default compose(
  connect(
    state => ({
      searchTerm: getSearchTermFromState(state),
      cardSearchResults: getCardSearchResultsFromState(state),
      groupSearchResults: getGroupSearchResultsFromState(state),
      dataState: getActionDataStateFromState(state, ACTIONS.SEARCH_VIEW),
    }),
    {
      dispatchSearch: searchView,
      dispatchClearSearch: clearSearch,
    },
  ),
  withStyles(styles),
)(SearchSidePanel);
